// Sustituto de 'firebase/functions': llama a POST /api/fn/<nombre>
import { apiCall } from './wire.js';

export function getFunctions() { return { region: 'local' }; }
export function connectFunctionsEmulator() {}

export function httpsCallable(functions, name) {
  const call = async (data) => {
    const res = await apiCall(`/fn/${encodeURIComponent(name)}`, { data: data === undefined ? null : data });
    return { data: res?.result ?? null };
  };
  return call;
}
export const httpsCallableFromURL = (functions, url) => httpsCallable(functions, String(url).split('/').pop());
